<!-- @format -->

<ng-container *transloco="let t">
  <dl class="d-flex flex-wrap">
    <div class="tiny-static-form-group sis-mr-xs">
      <dt class="label colon">{{ t("PLAN_EDIT.SELECTION_MODAL.RULE_HEADER.FIELDS.RULE") }}</dt>
      @if (targetCredits()) {
        <dd class="value" [attr.id]="ruleLegendId"
          >{{ t("PLAN_EDIT.SELECTION_MODAL.RULE_HEADER.RULE_CLAUSES.CHOOSE") + " " + (targetCredits() | creditRange) }}
        </dd>
      }
    </div>
    @if (!onlyShowRule) {
      @if (targetCredits()) {
        <div class="tiny-static-form-group sis-mr-xs">
          <dt class="label colon">{{ t("PLAN_EDIT.SELECTION_MODAL.RULE_HEADER.FIELDS.CHOSEN") }}</dt>
          <dd class="value">{{ (plannedCredits() | intRange) + "/" + (targetCredits() | creditRange) }}</dd>
        </div>
      }
      <div id="validation-state" class="tiny-static-form-group">
        <dt class="label colon">{{ t("PLAN_EDIT.SELECTION_MODAL.RULE_HEADER.FIELDS.STATE") }}</dt>
        @if (rangeValidationResultState() !== "OK" && rangeValidationResultState() !== "IMPLICIT_OK") {
          <dd class="value">{{ t("PLAN_EDIT.SELECTION_MODAL.RULE_HEADER.STATES." + rangeValidationResultState()) ?? "-" }} </dd>
        } @else {
          <dd class="value">{{ t("PLAN_EDIT.SELECTION_MODAL.RULE_HEADER.STATES." + planValidationState()) }}</dd>
        }
      </div>
    }
  </dl>
</ng-container>
